import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NewEventInvitation, EventInvitation, EventInvitationAnswer } from './event-invitation.types';

@Injectable()
export class EventInvitationService {
	private invitationUrl = 'api/invitations';
	private invitationsUrl = (eventId: number) => `api/events/${eventId}/invitations`;
	private previewUrl = (eventId: number) => `api/events/${eventId}/invitations/preview`;

	constructor(private _http: HttpClient) { }

	sendInvitations(eventId: number, invitation: NewEventInvitation): Promise<void> {
		return this._http.post<void>(this.invitationsUrl(eventId), invitation).toPromise();
	}

	openInvitation(encodedInvite: string): Promise<EventInvitation> {
		// due to + encoding bug in http have to put this in url for now.
		return this._http.get<EventInvitation>(`${this.invitationUrl}?encodedInvite=${encodeURIComponent(encodedInvite)}`).toPromise();
	}

	answerInvitation(encodedInvite: string, answer: EventInvitationAnswer): Promise<void> {
		// due to + encoding bug in http have to put this in url for now.
		return this._http.put<void>(`${this.invitationUrl}?encodedInvite=${encodeURIComponent(encodedInvite)}`, answer).toPromise();
	}
	previewInvitation(eventId: number, invitation: NewEventInvitation): Promise<string> {
		const options = {
			responseType: 'text' as 'text'
		};
		return this._http.post(this.previewUrl(eventId), invitation, options).toPromise();
	}
}
